var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.99807C0 7.59787 0.32443 7.27344 0.724635 7.27344H15.2826C15.6828 7.27344 16.0072 7.59787 16.0072 7.99807C16.0072 8.39828 15.6828 8.72271 15.2826 8.72271H0.724635C0.32443 8.72271 0 8.39828 0 7.99807Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99905 0C8.39925 0 8.72368 0.32443 8.72368 0.724635V15.2754C8.72368 15.6756 8.39925 16 7.99905 16C7.59884 16 7.27441 15.6756 7.27441 15.2754V0.724635C7.27441 0.32443 7.59884 0 7.99905 0Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 1.44927C4.38212 1.44927 1.44927 4.38214 1.44927 8C1.44927 11.6179 4.38212 14.5507 7.99997 14.5507C11.6178 14.5507 14.5507 11.6179 14.5507 8C14.5507 4.38214 11.6178 1.44927 7.99997 1.44927ZM0 8C0 3.58174 3.5817 0 7.99997 0C12.4182 0 15.9999 3.58174 15.9999 8C15.9999 12.4183 12.4182 16 7.99997 16C3.5817 16 0 12.4183 0 8Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fb8ef102a1e8e1b393c9d91f8fcf6be5.svg";
export { ForwardRef as ReactComponent };